import { BaseModel } from "../../shared/base.model";
import { DateUtil } from "../../shared/date_util";
import { TransferredDrone } from "./transferred-drone.model";

export class RegisteredDrone extends BaseModel {
    private _model: string = "";
    private _model_description: string = "";
    private _serial_number: string = "";
    private _remote_id: string = "";
    private _tail_number: string = "";
    private _manufacture_date: Date = new Date();

    private _drone_transfers: TransferredDrone[] = [];

    public get model(): string {
        return this._model;
    }

    public set model(value: string) {
        this._model = value;
    }

    public get model_description(): string {
        return this._model_description;
    }

    public set model_description(value: string) {
        this._model_description = value;
    }

    public get serial_number(): string {
        return this._serial_number;
    }

    public set serial_number(value: string) {
        this._serial_number = value;
    }

    public get remote_id(): string {
        return this._remote_id;
    }

    public set remote_id(value: string) {
        this._remote_id = value;
    }

    public get tail_number(): string {
        return this._tail_number;
    }

    public set tail_number(value: string) {
        this._tail_number = value;
    }

    public get manufacture_date(): Date {
        return this._manufacture_date;
    }

    public set manufacture_date(value: any) {
        this._manufacture_date = DateUtil.getDateFromValue(value);
    }

    public get drone_transfers(): TransferredDrone[] {
        return this._drone_transfers;
    }

    public set drone_transfers(value: TransferredDrone[]) {
        this._drone_transfers = value;
    }

    public static toRegisteredDrones(obj: string | Object[]): RegisteredDrone[] {
        let obj2 = obj;

        if (typeof obj === "string") {
            obj2 = JSON.parse(obj);
        }

        let registeredDrones: RegisteredDrone[] = [];

        for (const o2 of (<Object[]>obj2)) {
            registeredDrones.push(RegisteredDrone.toRegisteredDrone(o2));
        }

        return registeredDrones;
    }

    public static toRegisteredDrone(obj: string | Object): RegisteredDrone {
        let obj2 = obj;

        if (typeof obj === "string") {
            obj2 = JSON.parse(obj);
        }

        // Convert generic object to type of RegisteredDrone.
        let registeredDrone: RegisteredDrone = Object.assign(new RegisteredDrone(), obj2);

        if (registeredDrone.drone_transfers != null) {
            registeredDrone.drone_transfers = TransferredDrone.toTransferredDrones(registeredDrone.drone_transfers);
        }

        return registeredDrone;
    }
}    
